export default [
  {
    path: '/login/index',
    meta:{
      title: '登录'
    },
    component: (resolve) => require(['@/pages/login/index'], resolve)
  }
]
